module.exports = __webpack_public_path__ + "images/marketing_site/blog_headshot/scott_gibson.jpg";